import React from "react";
import { Navigate } from "react-router";
import { STORAGE_KEYS, getDataLocally } from "./localStorage";
import { isNull } from "./utils";

export default function PrivateRoute({children}) {
  const isLoggedIn = getDataLocally(STORAGE_KEYS.LOGIN_ORGANIZATION);
    return !isNull(isLoggedIn) ? children : (<Navigate replace={true} to="/" />)
} 